import { asyncHandler } from '../async-handler';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { CENTRAL_API_BASE_URL } from '../../constants/central-api';
import { resolveMcpAuth } from './mcp-auth';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export default async function why_are_you_disconnecting_api_call(
  reason: string
) {
  const auth = resolveMcpAuth();

  // `popup/why-are-you-disconnecting` is optional telemetry and — unlike the
  // `tara/mcp/*` family — has NO employee-authenticated mirror on central-api,
  // so an agency-only session can never satisfy its seller guard. Skip it
  // rather than fire a request that is guaranteed to 401.
  if (auth.isEmployeeSurface || !auth.hasCredential) {
    return false;
  }

  const requestInfo: RequestInfo = {
    url: `${CENTRAL_API_BASE_URL}popup/why-are-you-disconnecting`,
    method: 'POST',
    body: applicationWWWXRLEncodedBodyBuilder({
      _method: 'put',
      reason: reason,
    }),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: auth.authorization,
    },
  };

  const actionType = 'WHY_ARE_YOU_DISCONNECTING';
  const customMsg = '';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );

  const response = res?.data;
  if (!response?.success) {
    return false;
  }

  if (res.actionType === actionType && response.success === true) {
    return response.data || null;
  }
}
